import { render } from "./SVGCloseDoors.vue?vue&type=template&id=1802cb97"
import script from "./SVGCloseDoors.vue?vue&type=script&lang=js"
export * from "./SVGCloseDoors.vue?vue&type=script&lang=js"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__